// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oGqIw","col":"styles_col__25vN5"};